// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import {
    createElement,
    Alert,
    Button,
    Grid,
    GridCol,
    Icon,
    Media,
    MediaSection,
    Panel,
    Translate,
    PropTypes,
} from '@plesk/ui-library';
import RestartServer from './RestartServer';

const Overview = ({ onRestartServer, ...props }) => (
    <Alert intent="info" {...props}>
        <Grid gap="md" sm={2}>
            <GridCol>
                <Media image={<Icon src="images/repair.png" size="xxl" alt="Repair CP" />}>
                    <MediaSection>
                        <Translate content="Overview.description" />
                    </MediaSection>
                    <MediaSection>
                        <Translate content="Overview.loginDescription" />
                    </MediaSection>
                    <MediaSection>
                        <Button intent="primary" component="a" href="/" id="plesk-login"><Translate content="Overview.loginButton" /></Button>
                    </MediaSection>
                </Media>
            </GridCol>
            <GridCol>
                <Panel>
                    <Grid gap="md" sm={2}>
                        <GridCol>
                            <Media image={<Icon src="images/help.png" size="md" alt="Help" />}>
                                <MediaSection>
                                    <Translate
                                        content="Overview.helpCenterDescription"
                                        params={{
                                            link: (
                                                <a href="https://support.plesk.com" target="_blank" rel="noopener noreferrer">
                                                    <Translate content="Overview.helpCenter" />
                                                </a>
                                            ),
                                        }}
                                    />
                                </MediaSection>
                            </Media>
                        </GridCol>
                        <GridCol>
                            <RestartServer onRestartServer={onRestartServer} />
                        </GridCol>
                    </Grid>
                </Panel>
            </GridCol>
        </Grid>
    </Alert>
);

Overview.propTypes = {
    onRestartServer: PropTypes.func.isRequired,
};

export default Overview;



// WEBPACK FOOTER //
// ./app/repair/Overview/Overview.js